export default {
  'color1': '0XCB3590',
  'color2': '0X000000',
  'color3': '0X0000FF',
  'color4': '0X2C2D4C',
  'watermark': {
    'position': 0,
    'size': 50,
    'url': 0,
    'type': 0
  },
  'social': {
    'facebook': false,
    'twitter': false,
    'embed': false
  },
  'error': {}
}



// WEBPACK FOOTER //
// ./src/components/widgets/dacastPlayerTheme.js